import React, { useState } from "react";
import Image from "next/image";

const UspSolutionDesk: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="w-full md:pt-[40px] pt-[22px] md:pb-[90px] pb-[32px] justify-center bg-[#0C1F33] relative">
        <Image
          src="/usp/Frame.png"
          alt="Accountants "
          className="cursor-pointer absolute bottom-0 left-0 z-[0]"
          width={600}
          height={440}
          loading="lazy"
        />
        <div className="mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden">
          <div className="text-center">
            <h2 className="text-2xl lg:text-[36px] md:text-[36px] mb-3 font-semibold leading-normal tracking-[-1.08px] text-white text-center inline-block mx-auto px-[4px]">
              <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                Here’s Our Solution: US STEM Pathway for Indian Accountants
              </span>
            </h2>
          </div>
          <div className="flex justify-center items-center md:mt-[25px]">
            <div
              className="relative cursor-pointer"
              style={{ width: "960px", height: "506px" }}
              onClick={() => {
                openPopup("VWzM-bqssTk");
              }}
            >
              <Image
                src="/images/accounting/usp/miles-path.gif"
                alt="Accountants"
                className="cursor-pointer w-full rounded-[14px]"
                width={500}
                height={281}
              />

              <div className="flex items-center justify-center md:rounded-[15px] absolute left-0 right-0 bottom-[40%]">
                <Image
                  src="/images/accounting/usp/video-icon.png"
                  alt="Accountants"
                  className="cursor-pointer w-[70px]"
                  width={110}
                  height={110}
                />
              </div>
            </div>
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspSolutionDesk;
